module.exports = __webpack_public_path__ + "static/media/cookedfroglegs.ee77bce4.webp";